// define bounds for each rating category for proper score classification and bubble coloring
export type BoundsType = { min: number; max: number };
export type BoundsIdentifierType =
    | 'projectAndTeamRating'
    | 'tokenSupplyAndAllocationRating'
    | 'transactionsAndMarketStructureRating'
    | 'financialDisclosureRating'
    | 'total';
export const tokenTransparencyBounds: Record<BoundsIdentifierType, { min: number; max: number }> = {
    projectAndTeamRating: { min: 0, max: 10 },
    tokenSupplyAndAllocationRating: { min: 0, max: 18 },
    transactionsAndMarketStructureRating: { min: 0, max: 7 },
    financialDisclosureRating: { min: 0, max: 5 },
    total: { min: 0, max: 40 },
};
